import React, { useState } from 'react';

import {
  Box,
  IconButton,
  Paper,
  TextField,
  Typography
} from '@mui/material';

import {
  Check,
  Clear,
  DeleteOutlined,
  EditOutlined
} from '@mui/icons-material';

const initialReminders = [
  {
    id: 1,
    date: '07/24/2026',
    text: 'Review allergies and medication interactions'
  },
  {
    id: 2,
    date: '07/24/2026',
    text: 'Sign encounter notes'
  },
  {
    id: 3,
    date: '07/24/2026',
    text: 'Review imaging reports'
  },
  {
    id: 4,
    date: '07/24/2026',
    text: 'Refill prescription requests'
  }
];

const panelSx = {
  mt: 1,
  minHeight: 395,
  borderRadius: '8px',
  border: '1px solid #D9D9D9',
  boxShadow: 'none',
  overflow: 'hidden'
};

const RemindersPanel = () => {
  const [reminders, setReminders] =
    useState(initialReminders);

  const [newReminder, setNewReminder] = useState('');

  const handleAdd = () => {
    const value = newReminder.trim();

    if (!value) {
      return;
    }

    setReminders(current => [
      ...current,
      {
        id: Date.now(),
        date: '07/24/2026',
        text: value
      }
    ]);

    setNewReminder('');
  };

  const handleDelete = id => {
    setReminders(current =>
      current.filter(item => item.id !== id)
    );
  };

  return (
    <Paper sx={panelSx}>
      <Box
        sx={{
          minHeight: 48,
          px: 1.5,
          display: 'flex',
          alignItems: 'center',
          bgcolor: '#FAFAFA',
          borderBottom: '1px solid #E0E0E0'
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 500
          }}
        >
          Reminders
        </Typography>
      </Box>

      <Box
        sx={{
          px: 1.5,
          py: 1.25,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          borderBottom: '1px solid #E0E0E0'
        }}
      >
        <TextField
          fullWidth
          size="small"
          value={newReminder}
          placeholder="Add new reminder"
          onChange={event =>
            setNewReminder(event.target.value)
          }
          sx={{
            '& .MuiOutlinedInput-root': {
              height: 40
            },
            '& input': {
              fontSize: 13
            }
          }}
        />

        <IconButton
          onClick={handleAdd}
          sx={{
            color: '#2E9D45'
          }}
        >
          <Check fontSize="small" />
        </IconButton>

        <IconButton
          onClick={() => setNewReminder('')}
          sx={{
            color: '#F44336'
          }}
        >
          <Clear fontSize="small" />
        </IconButton>
      </Box>

      {reminders.map(reminder => (
        <Box
          key={reminder.id}
          sx={{
            minHeight: 54,
            px: 1.5,
            display: 'grid',
            gridTemplateColumns:
              '86px minmax(0, 1fr) 32px 32px',
            alignItems: 'center',
            columnGap: 0.5,
            borderBottom: '1px solid #EEEEEE',
            '&:hover': {
              bgcolor: '#FFF9F0'
            }
          }}
        >
          <Typography
            sx={{
              fontSize: 12,
              color: '#424242'
            }}
          >
            {reminder.date}
          </Typography>

          <Typography
            sx={{
              fontSize: 12,
              color: '#424242',
              lineHeight: 1.2
            }}
          >
            {reminder.text}
          </Typography>

          <IconButton size="small">
            <EditOutlined
              sx={{
                fontSize: 18,
                color: '#616161'
              }}
            />
          </IconButton>

          <IconButton
            size="small"
            onClick={() =>
              handleDelete(reminder.id)
            }
          >
            <DeleteOutlined
              sx={{
                fontSize: 18,
                color: '#616161'
              }}
            />
          </IconButton>
        </Box>
      ))}
    </Paper>
  );
};

export default RemindersPanel;